import { useEffect, useRef } from 'react'

import { useApolloClient } from '@apollo/client'

import { SyncRunStatus } from 'modules/integrations/public'

interface UseSyncCompletionOptions {
  lastSyncRun?: {
    status?: string
    finishedAt?: string
  } | null
  isSyncRunning?: boolean
  onSyncComplete?: () => void
}

export function useSyncCompletion({
  lastSyncRun,
  isSyncRunning = false,
  onSyncComplete,
}: UseSyncCompletionOptions) {
  const client = useApolloClient()
  const lastCompletedSyncRef = useRef<string | null>(null)

  useEffect(() => {
    const isSuccess =
      lastSyncRun?.status === SyncRunStatus.SUCCEEDED ||
      lastSyncRun?.status === SyncRunStatus.SUCCEEDED_WITH_ERRORS

    const syncCompleted = !isSyncRunning && isSuccess && lastSyncRun?.finishedAt

    const isNewCompletion =
      syncCompleted && lastCompletedSyncRef.current !== (lastSyncRun.finishedAt ?? null)

    if (isNewCompletion) {
      lastCompletedSyncRef.current = lastSyncRun.finishedAt ?? null

      client.cache.evict({ id: 'ROOT_QUERY', fieldName: 'compensations' })
      client.cache.gc()

      if (onSyncComplete) {
        onSyncComplete()
      }
    }
  }, [isSyncRunning, lastSyncRun?.status, lastSyncRun?.finishedAt, onSyncComplete, client])
}
